export const componentSettingsAutoSaveTimeInMs = 10000;
